<template>
  <div v-if="isVisible" class="box-container p-3">
    <div class="d-inline">
      <em class="far fa-exclamation-triangle text-danger" />
    </div>
    <p class="text-left d-inline">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ControversyErrorBox',
  props: {
    message: {
      type: String,
      required: true,
    },
    isVisible: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style scoped>
.box-container {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #ff5b5c;
  border-radius: 4px;
  opacity: 1;
}

.box-container p {
  text-align: left;
  font: Regular 16px/24px Lato;
  letter-spacing: 0;
  color: #ff5b5c;
  opacity: 1;
  margin: 15px 5px 15px 10px;
}
</style>
